import {useNavigationStore} from '../../../../../../../../Stores/navigation'

import LinksTile from '../../../../../../Widgets/LinksTile'
import LinksTileWithCategories from '../../../../../../Widgets/LinksTileWithCategories'
import TitleWidget from '../../../../../../Widgets/Title'
import BreadcrumbsWidget from '../../../../../../Widgets/Breadcrumbs'
import CKEditorContent from '../../../../../../Widgets/CKEditorContent'
import TopPagePicture from '../../../../../../Widgets/TopPagePicture'

import './index.scss'

export default function Template(props) {
    const {content, config, children, permits, breadcrumbs} = props

    const {contentLoading} = useNavigationStore()

    let hasCategories = false
    children.order.map(id => {
        if (hasCategories) return;

        if (children.list[id].category) {
            hasCategories = true;
        }
    })

    return <div className='TileSections'>
        <TopPagePicture cutHeightForDesktop image={content.banner} />
        {/* showSkeleton={contentLoading}  */}

        <TitleWidget permits={permits} content={content} config={config} breadcrumbs={breadcrumbs} hide={content.hideTitle} />
        <BreadcrumbsWidget links={breadcrumbs} hide={content.hideBreadcrumbs}/>

        {config?.templateOptions?.descriptionPosition !== 'bottom' && <CKEditorContent content={content.description} />}

        {(!hasCategories && !config.categories) && <LinksTile
            spacing={1}
            xs={4}
            md={2}
            imgLoading={config?.templateOptions?.imgLoading}

            order={config.childrenOrder || content.childrenOrder}
            showFilters={config?.showFilters || content?.showFilters}
            showSkeleton={contentLoading}
            links={children}
            isExternalLinksSection={config?.templateOptions?.isExternalLinksSection}
        />}

        {(hasCategories || config.categories) && <LinksTileWithCategories
            spacing={1}
            xs={4} md={3}
            permits={permits}
            
            // order={config.childrenOrder || content.childrenOrder}
            categoriesConfig={config.categories}
            showFilters={config?.showFilters || content?.showFilters}
            showSkeleton={contentLoading}
            links={children}
            isExternalLinksSection={config?.templateOptions?.isExternalLinksSection}
        />}

        {config?.templateOptions?.descriptionPosition === 'bottom' && <CKEditorContent content={content.description} />}
    </div>
}
